import React from "react"
import types from "prop-types"
import { adminSolutionPath } from "utils/routeHelpers"
import ItemRow from "shared/ItemRow"
import EmptyCategories from "./EmptyCategories"
import CategoryMenu from "./CategoryMenu"

const CategoryList = ({ categories }) => {
  if (categories.length === 0) return <EmptyCategories />

  return (
    <div>
      {
        categories.map((category) => {
          const { id, name, slug } = category

          return (
            <ItemRow
              key={id}
              itemRowHeaderContent={(
                <a className="w-full text-inherit" href={adminSolutionPath(slug)}>{name}</a>
              )}
              itemRowHeaderControls={(
                <CategoryMenu category={category} />
              )}
            />
          )
        })
      }
    </div>
  )
}

CategoryList.propTypes = {
  categories: types.arrayOf(types.object).isRequired,
}

export default CategoryList
